import {message} from 'antd';
import {includes} from 'lodash';
import filesize from 'filesize';
import uuid from 'uuid/v4';
import firebase from './firebase';


export const fileTypes = [
    "image/jpeg",
    "image/png",
    "image/webp"
];

export const onFileChange = (e) => {

    const file = e.target.files[0];
    const size = filesize(file.size, {exponent: 2, output: 'object'});

    if (!includes(fileTypes, file.type)) {

        message.error('Invalid file type');

        return false;

    } else if (size.value > 5) {

        message.error('Filesize exceeds the limit of 5MB');

        return false;


    } else {

        //upload

        return file;

    }

};

export const uploadImage = (file, cb) => {

    const storageRef = firebase.storage().ref('images');
    const fileId = uuid();
    const ref = storageRef.child(`${fileId}`);

    ref.put(file).then(async (snapshot) => {

        return cb(await snapshot.ref.getDownloadURL());

    });

}